import React, { Fragment, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { reduxForm } from 'redux-form';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import AppointmentFilter from './components/AppointmentFilter';
import MaterialTable from '../../shared/components/material-table';
import columns from './components/Columns';
import {
  itensTabletActiveListByNivel,
  employeeListByFilter,
  noteByFilterForGrid,
  noteById,
  saveEditNote,
  deleteNotes,
} from '../../shared/queries/Appointment';
import { classListActivesByFunc } from '../../shared/queries/SchoolClass';
import GraphQl from '../../GraphQL';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import { DEFAULT_PAGE_SIZE } from '../../shared/utils/constants';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import EditAppointmentModal from './components/EditAppointmentModal';
import Modal from '../../shared/components/Modal';
import { studentListByFilter } from '../../shared/queries/Student';
import FullScreenDialog from '../../shared/components/FullScreenDialog';
import { updatePendency } from '../../shared/utils/smartutils';

const Appointment = (props) => {
  const { t, history, dispatch } = props;
  const [itens, setItens] = useState([]);
  const [classes, setClasses] = useState([]);
  const [students, setStudents] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [filterisOpen, setFilterIsOpen] = useState(false);
  const [lastFilter, setLastFilter] = useState({
    initialDate: new Date(),
    finalDate: new Date(),
    normalSinc: true,
    regularSinc: true,
    badSinc: true,
  });
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedDto, setSelectedDto] = useState({});
  const [note, setNote] = useState();
  const [studentName, setStudentName] = useState();
  const [deleteModal, setDeleteModal] = useState(false);

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const toggleModal = () => {
    setModal(!modal);
  };

  const toggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };

  const listItens = () => {
    const query = itensTabletActiveListByNivel();
    showLoading();
    GraphQl(query, {}).then((res) => {
      res.itensTabletActiveListByNivel = res.itensTabletActiveListByNivel.map(
        (item) => ({
          ...item,
          label: item.name,
          value: item.id,
        })
      );
      setItens(res.itensTabletActiveListByNivel);
    });
    hideLoading();
  };

  const listClasses = () => {
    const query = classListActivesByFunc();
    GraphQl(query, {}).then((res) => {
      res.classListActivesByFunc = res.classListActivesByFunc.map((item) => ({
        ...item,
        label: item.name,
        value: item.id,
      }));
      setClasses(res.classListActivesByFunc);
    });
  };

  const listStudents = () => {
    const filter = {
      id: 0,
      classes: [],
      responsibles: [],
      menus: [],
      onlyActive: true,
    };

    const query = studentListByFilter(filter);
    GraphQl(query, {}).then((res) => {
      res.studentListByFilter = res.studentListByFilter.map((item) => ({
        ...item,
        label: item.fullName,
        value: item.id,
      }));
      setStudents(res.studentListByFilter);
    });
  };

  const listEmployees = () => {
    const query = employeeListByFilter();
    GraphQl(query, {}).then((res) => {
      res.employeeListByFilter = res.employeeListByFilter.map((item) => ({
        ...item,
        label: item.name,
        value: item.id,
      }));
      setEmployees(res.employeeListByFilter);
    });
  };

  const addItemClickHandler = () => {
    history.push('/minime/apontamento/mnt/0');
  };

  const onFilterToggle = () => {
    setFilterIsOpen(!filterisOpen);
  };

  const loadData = (filter) => {
    if (filterisOpen) {
      onFilterToggle();
    }
    showLoading();
    if (!filter.initialDate || !filter.finalDate) {
      hideLoading();
      showNotificationAutoDestroy(
        'warning',
        t('notifications.attention'),
        t('notifications.warning-no-date-selected')
      );
    } else {
      const query = noteByFilterForGrid(filter);
      GraphQl(query, {})
        .then((res) => {
          if (res.noteByFilterForGrid) {
            res.noteByFilterForGrid = res.noteByFilterForGrid.map((item) => ({
              ...item,
              auditStatus: t(`audit-status.${item.status}`),
            }));
          }
          setData(res.noteByFilterForGrid);
        })
        .catch((error) => {
          console.error(error);
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        })
        .finally(() => {
          hideLoading();
        });
    }
  };

  const onFilterClickHandler = (filter) => {
    if (filter) {
      setLastFilter(filter);
      loadData(filter);
    } else if (lastFilter) {
      loadData(lastFilter);
    }
  };

  const editItemClickHandler = (evt, rowData) => {
    setNote(rowData.note);
    setStudentName(rowData.studentName);
    const query = noteById(rowData.id);
    GraphQl(query, {}).then((res) => {
      if (res.noteById) {
        setSelectedDto({
          ...res.noteById,
          class: res.noteById.class.name,
        });
      }
    });

    toggleModal();
  };

  const removeItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      ...rowData,
    });
    toggleDeleteModal();
  };

  const filterBuildFunction = () => (
    <AppointmentFilter
      filterToggle={onFilterToggle}
      isFiltering={filterisOpen}
      filterClick={onFilterClickHandler}
      itens={itens}
      classes={classes}
      students={students}
      employees={employees}
      lastFilter={lastFilter}
    />
  );

  const updateItem = (value) => {
    const mutation = saveEditNote(value);
    GraphQl(mutation, {})
      .then((res) => {
        if (res.saveNotes) {
          toggleModal();
          showNotificationAutoDestroy(
            'success',
            t('success.title'),
            t('success.successfully-saved')
          );
          loadData(lastFilter);
        }
      })
      .catch(() => {
        toggleModal();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      })
      .finally(() => {
        updatePendency(dispatch);
      });
  };

  const deleteItem = () => {
    if (deleteModal) {
      toggleDeleteModal();
    }
    showLoading();
    const removeMutation = deleteNotes(selectedDto.id);
    GraphQl(removeMutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
        loadData(lastFilter);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-remove')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  useEffect(() => {
    listItens();
    listClasses();
    listStudents();
    listEmployees();
    onFilterClickHandler();
  }, []);
  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="warning"
        message={t('notifications.delete_modal')}
        toggle={toggleDeleteModal}
        modal={deleteModal}
        onConfirm={deleteItem}
      />
      <FullScreenDialog
        toggleDialog={toggleModal}
        title={t('mnt_appointment.appointment-edit')}
        isOpen={modal}
      >
        <EditAppointmentModal
          dto={selectedDto}
          currentValue={note}
          student={studentName}
          updateItem={updateItem}
        />
      </FullScreenDialog>

      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MaterialTable
                    showFilter
                    data={data}
                    isFiltering={filterisOpen}
                    filterToggle={onFilterToggle}
                    filterBuildFunction={filterBuildFunction}
                    columns={columns(t)}
                    pageSize={DEFAULT_PAGE_SIZE}
                    onRefreshClick={() => onFilterClickHandler()}
                    onAddClick={addItemClickHandler}
                    onEditClick={editItemClickHandler}
                    onRemoveClick={removeItemClickHandler}
                    title={t('mnt_appointment.title')}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

Appointment.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'Appointment',
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(Appointment));
